function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
import { Command, Plugin, icons } from '@ckeditor/ckeditor5-core/dist/index.js';
import { findOptimalInsertionRange, toWidget, Widget } from '@ckeditor/ckeditor5-widget/dist/index.js';
import { ButtonView, MenuBarMenuListItemButtonView } from '@ckeditor/ckeditor5-ui/dist/index.js';
/**
 * The horizontal line command.
 *
 * The command is registered by {@link module:horizontal-line/horizontallineediting~HorizontalLineEditing} as `'horizontalLine'`.
 *
 * To insert a horizontal line at the current selection, execute the command:
 *
 * ```ts
 * editor.execute( 'horizontalLine' );
 * ```
 */

var HorizontalLineCommand = /*#__PURE__*/function (_Command) {
  _inherits(HorizontalLineCommand, _Command);

  var _super = _createSuper(HorizontalLineCommand);

  function HorizontalLineCommand() {
    _classCallCheck(this, HorizontalLineCommand);

    return _super.apply(this, arguments);
  }

  _createClass(HorizontalLineCommand, [{
    key: "refresh",
    value:
    /**
    * @inheritDoc
    */
    function refresh() {
      var model = this.editor.model;
      var schema = model.schema;
      var selection = model.document.selection;
      this.isEnabled = isHorizontalLineAllowedInParent(selection, schema, model);
    }
    /**
    * Executes the command.
    *
    * @fires execute
    */

  }, {
    key: "execute",
    value: function execute() {
      var model = this.editor.model;
      model.change(function (writer) {
        var horizontalElement = writer.createElement('horizontalLine');
        model.insertObject(horizontalElement, null, null, {
          setSelection: 'after'
        });
      });
    }
  }]);

  return HorizontalLineCommand;
}(Command);
/**
 * Checks if a horizontal line is allowed by the schema in the optimal insertion parent.
 *
 * @param model Model instance.
 */


function isHorizontalLineAllowedInParent(selection, schema, model) {
  var parent = getInsertHorizontalLineParent(selection, model);
  return schema.checkChild(parent, 'horizontalLine');
}
/**
 * Returns a node that will be used to insert a horizontal line with `model.insertContent` to check if the horizontal line can be
 * placed there.
 *
 * @param model Model instance.
 */


function getInsertHorizontalLineParent(selection, model) {
  var insertionRange = findOptimalInsertionRange(selection, model);
  var parent = insertionRange.start.parent;

  if (parent.isEmpty && !parent.is('element', '$root')) {
    return parent.parent;
  }

  return parent;
}
/**
 * The horizontal line editing feature.
 */


var HorizontalLineEditing = /*#__PURE__*/function (_Plugin) {
  _inherits(HorizontalLineEditing, _Plugin);

  var _super2 = _createSuper(HorizontalLineEditing);

  function HorizontalLineEditing() {
    _classCallCheck(this, HorizontalLineEditing);

    return _super2.apply(this, arguments);
  }

  _createClass(HorizontalLineEditing, [{
    key: "init",
    value:
    /**
    * @inheritDoc
    */
    function init() {
      var editor = this.editor;
      var schema = editor.model.schema;
      var t = editor.t;
      var conversion = editor.conversion;
      schema.register('horizontalLine', {
        inheritAllFrom: '$blockObject'
      });
      conversion.for('dataDowncast').elementToElement({
        model: 'horizontalLine',
        view: function view(modelElement, _ref) {
          var writer = _ref.writer;
          return writer.createEmptyElement('hr');
        }
      });
      conversion.for('editingDowncast').elementToStructure({
        model: 'horizontalLine',
        view: function view(modelElement, _ref2) {
          var writer = _ref2.writer;
          var label = t('Horizontal line');
          var viewWrapper = writer.createContainerElement('div', null, writer.createEmptyElement('hr'));
          writer.addClass('ck-horizontal-line', viewWrapper);
          writer.setCustomProperty('hr', true, viewWrapper);
          return toHorizontalLineWidget(viewWrapper, writer, label);
        }
      });
      conversion.for('upcast').elementToElement({
        view: 'hr',
        model: 'horizontalLine'
      });
      editor.commands.add('horizontalLine', new HorizontalLineCommand(editor));
    }
  }], [{
    key: "pluginName",
    get:
    /**
    * @inheritDoc
    */
    function get() {
      return 'HorizontalLineEditing';
    }
  }]);

  return HorizontalLineEditing;
}(Plugin);
/**
 * Converts a given {@link module:engine/view/element~Element} to a horizontal line widget:
 * * Adds a {@link module:engine/view/element~Element#_setCustomProperty custom property} allowing to
 *   recognize the horizontal line widget element.
 * * Calls the {@link module:widget/utils~toWidget} function with the proper element's label creator.
 *
 * @param writer An instance of the view writer.
 */


function toHorizontalLineWidget(viewElement, writer, label) {
  writer.setCustomProperty('horizontalLine', true, viewElement);
  return toWidget(viewElement, writer, {
    label: label
  });
}
/**
 * The horizontal line UI plugin.
 */


var HorizontalLineUI = /*#__PURE__*/function (_Plugin2) {
  _inherits(HorizontalLineUI, _Plugin2);

  var _super3 = _createSuper(HorizontalLineUI);

  function HorizontalLineUI() {
    _classCallCheck(this, HorizontalLineUI);

    return _super3.apply(this, arguments);
  }

  _createClass(HorizontalLineUI, [{
    key: "init",
    value:
    /**
    * @inheritDoc
    */
    function init() {
      var _this = this;

      var editor = this.editor; // Add the `horizontalLine` button to feature components.

      editor.ui.componentFactory.add('horizontalLine', function () {
        var buttonView = _this._createButton(ButtonView);

        buttonView.set({
          tooltip: true
        });
        return buttonView;
      });
      editor.ui.componentFactory.add('menuBar:horizontalLine', function () {
        return _this._createButton(MenuBarMenuListItemButtonView);
      });
    }
    /**
    * Creates a button for horizontal line command to use either in toolbar or in menu bar.
    */

  }, {
    key: "_createButton",
    value: function _createButton(ButtonClass) {
      var editor = this.editor;
      var locale = editor.locale;
      var command = editor.commands.get('horizontalLine');
      var view = new ButtonClass(editor.locale);
      var t = locale.t;
      view.set({
        label: t('Horizontal line'),
        icon: icons.horizontalLine
      });
      view.bind('isEnabled').to(command, 'isEnabled'); // Execute the command.

      this.listenTo(view, 'execute', function () {
        editor.execute('horizontalLine');
        editor.editing.view.focus();
      });
      return view;
    }
  }], [{
    key: "pluginName",
    get:
    /**
    * @inheritDoc
    */
    function get() {
      return 'HorizontalLineUI';
    }
  }]);

  return HorizontalLineUI;
}(Plugin);
/**
 * The horizontal line feature.
 *
 * It provides the possibility to insert a horizontal line into the rich-text editor.
 *
 * For a detailed overview, check the {@glink features/horizontal-line Horizontal line feature} documentation.
 */


var HorizontalLine = /*#__PURE__*/function (_Plugin3) {
  _inherits(HorizontalLine, _Plugin3);

  var _super4 = _createSuper(HorizontalLine);

  function HorizontalLine() {
    _classCallCheck(this, HorizontalLine);

    return _super4.apply(this, arguments);
  }

  _createClass(HorizontalLine, null, [{
    key: "requires",
    get:
    /**
    * @inheritDoc
    */
    function get() {
      return [HorizontalLineEditing, HorizontalLineUI, Widget];
    }
    /**
    * @inheritDoc
    */

  }, {
    key: "pluginName",
    get: function get() {
      return 'HorizontalLine';
    }
  }]);

  return HorizontalLine;
}(Plugin);

export { HorizontalLine, HorizontalLineEditing, HorizontalLineUI };